/**
 * PrintService_escpos.js — Maquetación v12.0 (REPORTE PROFESIONAL)
 * Optimizado para 80mm (48 caracteres por línea)
 * Foco: Estilo Impasto en Reportes y Alineación Perfecta.
 */

const COLS = 48;

const E = {
    INIT: '\x1B@',
    LF: '\n',
    CUT: '\x1DVB\x01',
    BEEP: '\x1BB\x01\x03',
    CT: '\x1Ba\x01',
    LT: '\x1Ba\x00',
    RT: '\x1Ba\x02',
    BOLD_ON: '\x1BE\x01',
    BOLD_OFF: '\x1BE\x00',
    INV_ON: '\x1DB\x01',
    INV_OFF: '\x1DB\x00',
    NORMAL: '\x1D!\x00',
    DBL_HEIGHT: '\x1B!\x10',
    DBL_WIDTH: '\x1B!\x20',
    DBL_BOTH: '\x1D!\x11',
    GIANT: '\x1D!\x22',
};

const hr = (char = '-') => char.repeat(COLS) + '\n';

/**
 * Alineación Izquierda-Derecha exacta para 48 columnas
 */
const leftRight = (left, right, width = COLS) => {
    const spaceCount = width - left.length - right.length;
    return left + ' '.repeat(Math.max(1, spaceCount)) + right;
};

/**
 * Barra negra sólida con texto (Estilo Impasto)
 */
const inverseBar = (text) => {
    const padding = Math.max(0, Math.floor((COLS - text.length) / 2));
    const line = ' '.repeat(padding) + text + ' '.repeat(COLS - text.length - padding);
    return E.INV_ON + E.BOLD_ON + E.DBL_HEIGHT + line.substring(0, COLS) + E.NORMAL + E.INV_OFF + '\n';
};

const fmtDate = (iso) => {
    try {
        const d = iso ? new Date(iso) : new Date();
        const dd = String(d.getDate()).padStart(2, '0');
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const yy = d.getFullYear();
        const h = String(d.getHours()).padStart(2, '0');
        const mi = String(d.getMinutes()).padStart(2, '0');
        return `${dd}/${mm}/${yy} ${h}:${mi}`;
    } catch { return ''; }
};

/**
 * REPORTE DE CAJA (DISEÑO PROFESIONAL v12.0)
 */
export const print_sales_report = (data) => {
    let r = E.INIT + E.CT;

    // 1. CABECERA GIGANTE
    r += E.BOLD_ON + E.DBL_WIDTH + "Conexo POS" + E.NORMAL + '\n';
    r += E.CT + "ALMERIA, ESPAÑA\n";
    r += hr('=');
    r += '\n';

    // 2. BARRA DE TÍTULO
    r += inverseBar("REPORTE DE VENTAS");
    r += E.CT + "FECHA: " + fmtDate() + '\n';
    r += E.CT + "PERIODO: HOY\n\n";

    // 3. BLOQUE DE RESUMEN (Sin bordes rotos)
    r += E.LT + E.BOLD_ON + "RESUMEN DE CAJA" + E.BOLD_OFF + '\n';
    r += hr();
    r += leftRight("Pedidos Totales:", String(data.total_orders || 0)) + '\n';
    r += leftRight("Pedidos Pendientes:", String(data.pending_orders || 0)) + '\n';
    r += leftRight("Ticket Promedio:", (data.average || 0).toFixed(2) + " EUR") + '\n';
    r += hr() + '\n';

    // 4. BLOQUE DE TOTAL IMPACTANTE
    r += inverseBar("TOTAL VENTAS DEL DIA");
    r += '\n';
    r += E.CT + E.BOLD_ON + E.GIANT + (data.total_sales || 0).toFixed(2) + " EUR" + E.NORMAL + E.BOLD_OFF + '\n';
    r += '\n';

    r += '\n\n\n\n' + E.CUT;
    return r;
};

/**
 * TICKET CLIENTE
 */
export const ticketCliente = (order, restaurantName = 'Conexo POS') => {
    const orderId = (order.order_id || '---').slice(-6).toUpperCase();
    const mesa = order.table_number ? 'MESA: ' + order.table_number : 'LOCAL';

    let r = E.INIT;
    r += E.CT + E.BOLD_ON + E.DBL_WIDTH + restaurantName.toUpperCase() + E.NORMAL + '\n';
    r += E.CT + "ALMERIA, ESPAÑA\n";
    r += E.CT + "FECHA: " + fmtDate(order.created_at) + '\n';
    r += hr();

    r += E.LT + E.BOLD_ON + "PEDIDO: #" + orderId + E.BOLD_OFF + '\n';
    r += E.LT + E.BOLD_ON + "UBICACION: " + E.BOLD_OFF + mesa + '\n';
    r += '\n';

    r += inverseBar(orderId);
    r += '\n';

    r += E.LT + E.BOLD_ON + "PRODUCTOS" + E.BOLD_OFF + '\n';
    r += hr();

    r += E.LT + E.BOLD_ON;
    for (const item of order.items || []) {
        const qty = item.quantity || 1;
        const price = ((item.price || 0) * qty).toFixed(2) + " EUR";
        r += E.DBL_HEIGHT + leftRight(`${qty}x ${item.name.toUpperCase()}`, price) + E.NORMAL + E.BOLD_ON + '\n';
    }
    r += E.BOLD_OFF + E.NORMAL;

    r += hr('.');
    r += E.CT + E.BOLD_ON + E.GIANT + "TOTAL: " + (order.total || 0).toFixed(2) + " EUR" + E.NORMAL + E.BOLD_OFF + '\n';

    r += '\n' + E.CT + "GRACIAS POR SU VISITA\n";
    r += '\n\n\n\n' + E.CUT;
    return r;
};

/** TICKET COCINA */
export const ticketCocina = (order) => {
    const orderId = (order.order_id || '---').slice(-4).toUpperCase();
    const mesa = order.table_number ? 'MESA ' + order.table_number : 'PARA LLEVAR';

    let r = E.INIT + E.BEEP;
    r += inverseBar("COCINA: " + mesa);
    r += E.CT + E.BOLD_ON + E.GIANT + "#" + orderId + E.NORMAL + '\n';
    r += hr('=');

    r += E.LT + E.BOLD_ON + E.DBL_HEIGHT;
    for (const item of order.items || []) {
        r += (item.quantity || 1) + 'x ' + item.name.toUpperCase() + '\n';
    }
    r += E.NORMAL + E.BOLD_OFF;
    r += '\n\n\n\n' + E.CUT;
    return r;
};

export const generarTicketEscPos = (order, restaurantName = 'Conexo POS', ticketType = 'customer') => {
    if (ticketType === 'kitchen') return ticketCocina(order);
    if (ticketType === 'report') return print_sales_report(order);
    return ticketCliente(order, restaurantName);
};

export default generarTicketEscPos;
